import {cloneDeep, set, unset} from 'lodash';

import {COLLAPSED_TREE_KEY} from '../constants';
import type {CollapsedTree} from '../types';
import {isCollapsed} from './isCollapsed';

const cleanPath = (collapsedTree: CollapsedTree, path: string[]) => {
  // If nothing is collapsed under a key, we don't need the key in our tree,
  // so delete it.
  // This keeps the tree as small as possible.
  if (path.length > 0 && typeof collapsedTree[path[0]] === 'object') {
    cleanPath(collapsedTree[path[0]] as CollapsedTree, [...path].splice(1));
    if (Object.keys(collapsedTree[path[0]] as CollapsedTree).length === 0) {
      delete collapsedTree[path[0]];
    }
  }
};

export const getNewCollapsedTree = (
  path: string[],
  collapsedTree?: CollapsedTree
) => {
  let newCollapsedTree: CollapsedTree;
  if (collapsedTree) {
    newCollapsedTree = cloneDeep(collapsedTree);
  } else {
    newCollapsedTree = {};
  }
  if (isCollapsed(path, newCollapsedTree)) {
    unset(newCollapsedTree, [...path, COLLAPSED_TREE_KEY]);
    cleanPath(newCollapsedTree, path);
  } else {
    set(newCollapsedTree, [...path, COLLAPSED_TREE_KEY], true);
  }
  return newCollapsedTree;
};
